import React from 'react';
import style from './WeeklyAnalysisCard.module.css';
import WeeklyBarChart from '../charts/WeeklyBarChart';

// const WeeklyAnalysisCard = ({ title, value, unit, dailyValues, maxValue, threshold, highlightOver, description }) => {
    const WeeklyAnalysisCard = ({ title, value, unit, dailyValues, maxValue, threshold, warnWhen = 'over', description }) => {
    return (
        <div className={style.card}>
            <div className={style.header}>
                <span className={style.title}>{title}</span>
                <span className={style.value}><strong>{value}</strong> {unit}</span>
            </div>

            <WeeklyBarChart
                dailyValues={dailyValues}
                maxValue={maxValue}
                threshold={threshold}
                // highlightOver={highlightOver}
                warnWhen={warnWhen}
            />

            {description && <p className={style.desc}>{description}</p>}
        </div>
    );
};

export default WeeklyAnalysisCard;